export enum SortEnums {
  ASC = 'asc',
  DESC = 'desc',
}
